<template>
  <full-container v-loading="loading" :element-loading-text="loadingText">
    <div slot="header" class="toolbar">
      <el-upload :before-upload="handleUpload" action="default" :disabled="loading">
        <el-button type="primary" size="small" icon="el-icon-upload"> 选择要导入的 .xlsx 表格 </el-button>
      </el-upload>
      <div>
        <el-input v-model="hours" style="width: 200px" prefix-icon="el-icon-watch" size="small">
          <el-button slot="append" type=" danger" icon="el-icon-caret-right" :disabled="loading" @click="onSubmit(0)">开始导入</el-button>
        </el-input>
      </div>
    </div>
    <el-table :data="datalist[pape]" stripe height="100%">
      <el-table-column label="询价标题" min-width="200">
        <template slot-scope="{ row }">
          <p>{{ row.Title }}</p>
          <p class="describe">{{ row.Code }} - {{ row.ModeText }}</p>
        </template>
      </el-table-column>
      <el-table-column label="客户信息" min-width="200">
        <template slot-scope="{ row }">
          <p>{{ row.Customer }}</p>
          <p class="describe">{{ row.Linkman }}-{{ row.Linktel }}</p>
        </template>
      </el-table-column>

      <el-table-column label="投标信息" min-width="200">
        <template slot-scope="{ row }">
          <p>
            预算<label style="color: #f00">￥{{ row.BudgetPrice }}</label>
          </p>
          <p class="describe">{{ row.BeginDate }}-{{ row.ExpiryDate }}</p>
          <p class="describe">已投标{{ row.Tendered }}</p>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="size" :total="total" @current-change="onPager" />
  </full-container>
</template>

<script>
import Vue from 'vue'
import pluginImport from '@d2-projects/vue-table-import'
Vue.use(pluginImport)
export default {
  data () {
    return {
      loading: false,
      loadingText: "",
      datalist: [],
      total: 0,
      pape: 0,
      size: 200,
      hours: 24
    }
  },
  methods: {
    //上传文件
    handleUpload (file) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.loadingText = "正在加载文件数据..."
      this.$import
        .xlsx(file)
        .then(({ results }) => {
          this.total = results.length
          this.datalist = this.splitArr(results.map(row => {
            return {
              Mode: this.formatMode(row['类别']),
              ModeText: row['类别'],
              Code: row['询价单编号'],
              Title: row['询价标题'],
              Column: row['采购目录'],
              Customer: row['采购单位'],
              Linkman: row['联系人'],
              Linktel: row['联系方式'],
              Address: row['送货地址'],
              BeginDate: row['报价开始时间'],
              ExpiryDate: row['报价结束时间'],
              Hours: this.hours || 24,
              BudgetPrice: this.formatPrice(row['预算总额']),
              Demands: row['商务要求'] + (row['附件信息'] ? '\n附件信息：' + row['附件信息'] : ''),
              Tendered: row['已报价']
            }
          }), this.size)
        })
        .catch((e) => {
          this.$message.error(e)
        }).finally(() => {
          this.loading = false
        })
      return false
    },
    formatMode (val) {
      switch (val) {
        case "在线询价": { return 1 }
        case "反向竞价": { return 2 }
        default: return 0
      }
    },
    formatPrice (val) {
      if (val.includes("万元")) {
        return parseInt(val) * 10000
      }
      return parseInt(val)
    },

    // 分页触发事件
    onPager (val) {
      this.pape = val - 1
    },

    //分页
    splitArr (data, senArrLen) {
      //处理成len个一组的数据
      let data_len = data.length
      let arrOuter_len = data_len % senArrLen === 0 ? data_len / senArrLen : parseInt((data_len / senArrLen) + '') + 1
      let arrSec_len = data_len > senArrLen ? senArrLen : data_len//内层数组的长度
      let arrOuter = new Array(arrOuter_len)//最外层数组
      let arrOuter_index = 0//外层数组的子元素下标
      for (let i = 0; i < data_len; i++) {
        if (i % senArrLen === 0) {
          arrOuter_index++
          let len = arrSec_len * arrOuter_index
          //将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
          arrOuter[arrOuter_index - 1] = new Array(data_len % senArrLen)
          if (arrOuter_index === arrOuter_len)//最后一组
            data_len % senArrLen === 0 ?
              len = data_len % senArrLen + senArrLen * arrOuter_index :
              len = data_len % senArrLen + senArrLen * (arrOuter_index - 1)
          let arrSec_index = 0//第二层数组的索引
          for (let k = i; k < len; k++) {//第一层数组的开始取决于第二层数组长度*当前第一层的索引
            arrOuter[arrOuter_index - 1][arrSec_index] = data[k]
            arrSec_index++
          }
        }
      }
      return arrOuter
    },
    //提交数据
    onSubmit (index) {
      if (index < 0) { index = 0 }

      if (!this.loading) {
        this.loading = true
      }
      this.loadingText = "正在上传第" + (index + 1) + "页"
      this.$apis.project.inquiry.import(this.datalist[index])
        .catch((res) => {
          this.$message.error(res)
        })
        .finally(() => {
          if (!this.datalist[index + 1]) {
            this.$message({ message: '数据全部已上传', type: 'success' })
            this.loading = false
          }
          else {
            this.onSubmit(index + 1)
          }
        })
    },
  }
}
</script>
